const sumCents = (rows) =>
  rows.reduce((sum, r) => sum + Math.round((Number(r.value) || 0) * 100), 0);

// Linha unificada de um recebimento/pagamento de rateio no extrato. Espelha o
// shape de um movimento cru (o extrato lê os mesmos campos), somando o valor.
const buildGroupRow = (members) => {
  const first = members[0];
  const entry = first.financial_entry || {};
  return {
    ...first,
    id: `stmt-os-${entry.order_service_id}-${first.installment_number}-${first.payment_date}-${first.bank_id}`,
    isGroup: true,
    value: sumCents(members) / 100,
  };
};

// Agrupa, SÓ para exibição no extrato, os movimentos do rateio de uma mesma OS
// (mesma order_service_id + número de parcela) pagos no MESMO evento (mesma
// payment_date + mesmo bank_id) numa linha só, com o valor somado. Movimentos
// sem OS ou de categoria única passam intactos. Não altera dados — a DRE e o
// saldo do banco seguem inalterados.
export const groupStatementRows = (movements) => {
  const groups = new Map();
  const slots = [];

  movements.forEach((movement) => {
    const osId = movement.financial_entry?.order_service_id;
    if (!osId) {
      slots.push(movement);
      return;
    }
    const key = `${osId}-${movement.installment_number}-${movement.payment_date}-${movement.bank_id}`;
    if (!groups.has(key)) {
      groups.set(key, []);
      slots.push(key);
    }
    groups.get(key).push(movement);
  });

  return slots.map((slot) => {
    if (typeof slot !== 'string') return slot;
    const members = groups.get(slot);
    if (members.length === 1) return members[0];
    return buildGroupRow(members);
  });
};
